<template lang="html">
  <div class="toBeCorrectedWrapper">
    <div class="search-form">
        <el-form label-position="left" label-width="130px" :model="searchParams">
            <el-row>
                <el-col :span="8">
                    <el-form-item>
                      <div slot="label" class="form-label">
                          模考:
                      </div>
                      <el-input v-model="searchParams.moKao" placeholder="请输入名称/ID" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item>
                      <div slot="label" class="form-label">
                          提交时间:
                      </div>
                      <!-- <el-input v-model="form.job_id" placeholder="请输入" maxlength=10 clearable></el-input> -->
                      <el-date-picker
                        v-model="searchParams.submitTime"
                        type="daterange"
                        prefix-icon="null"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                      </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item>
                      <div slot="label" class="form-label">
                          学员手机号:
                      </div>
                      <el-input v-model="searchParams.studentPhone" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8" :offset="16">
                    <div class="button-group">
                        <el-button type="primary" @click="search">查询</el-button>
                        <el-button @click="initForm">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
    <!-- 释放批改任务 -->
    <div class="my-correction-data">
      <div class="opertion-wrapper">
        <el-button icon="el-icon-document-remove" @click="releaseTask(false)">释放批改任务</el-button>
        <span v-if="!ifSearch">共{{total}}条数据</span>
        <span v-else>共筛选出{{total}}条数据</span>
      </div>
      <!-- 表格 -->
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="批改任务">
          <template slot-scope="scope">
            <div>
              <p class="mock-name"><span>模考</span>{{scope.row.mock_name}}</p>
              <p class="mock-info">
                <span>模考ID：{{scope.row.mock_id}}</span> |
                <el-popover
                  placement="right"
                  title=""
                  width="300"
                  trigger="hover"
                  :content="`模考科目：${scope.row.mock_subject_name}`">
                  <span slot="reference" class="mock-course">模考科目：{{scope.row.mock_subject_name}}</span>
                </el-popover>
              </p>
              <el-popover
                placement="right"
                title=""
                width="300"
                trigger="hover">
                <div>
                  <p>考试：{{scope.row.exam_name}}</p>
                  <p>子模考：{{scope.row.mock_sub_name ? scope.row.mock_sub_name : '无'}}</p>
                </div>
                <span slot="reference" class="mock-child blue">子模考</span>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="提交时间">
          <div slot-scope="scope">
            {{scope.row.submit_time}}
          </div>
        </el-table-column>
        <el-table-column label="学员信息">
          <div slot-scope="scope">
            <div>
              <p class="user-name">{{scope.row.student_name}}</p>
              <p>{{scope.row.student_phone}}</p>
            </div>
          </div>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <div class="box-operate">
              <a href="javascript:void(0);" class="blue" @click="toPigai(scope.row)">人工批改</a>
              <span class="divide-line">|</span>
              <a href="javascript:void(0);" class="blue" @click="releaseTask(scope.row)">释放</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="total > 0"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="prev, pager, next, sizes, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchParams: {
        moKao: '',
        submitTime: '',
        studentPhone: ''
      },
      tableData: [],
      page: 1,
      pageSize: 20,
      allTobeCorrectedTotal: 0,
      allCorrectedTotal: 0,
      total: 0,
      ifSearch: false,
      selectionIds: []
    }
  },
  created () {
    this.getMyTaskList()
  },
  methods: {
    getMyTaskList () {
      let params = {
        correct_status: 0, // 待批改
        search_text: this.searchParams.moKao,
        submit_time_begin: this.searchParams.submitTime && this.searchParams.submitTime[0],
        submit_time_end: this.searchParams.submitTime && this.searchParams.submitTime[1],
        phone: this.searchParams.studentPhone,
        page: this.page,
        page_size: this.pageSize
      }
      this.$api.GETMYCORRECTTASK(params).then((res) => {
          if (res.retcode === 0) {
            if (!this.ifSearch) {
              this.total = res.data.not_correct_total
            } else {
              this.total = res.data.search_total
            }
            this.$emit('getAllTobeCorrectedTotal', res.data.not_correct_total)
            this.$emit('getAllCorrectedTotal', res.data.has_correct_total)
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
      })
    },
    // 释放
    releaseTask (row) {
      console.log(row)
      if (!row && this.selectionIds.length === 0) {
        this.$message({
          message: '清先勾选要释放的任务',
          type: 'warning'
        })
      } else {
        this.$confirm('确认要释放所选批改任务吗？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {}
          if (row) {
            params.correct_collection_ids = String(row.correct_collection_id)
          } else {
            params.correct_collection_ids = this.selectionIds.join(',')
          }
          this.$api.CORRECTRELEASE(params).then((res) => {
            if (res.retcode === 0) {
              this.$message({
                type: 'success',
                message: '释放成功!'
              })
              this.getMyTaskList()
            } else {
              this.$message.error(res.message)
            }
          })
        }).catch(() => {
        })
      }
    },
    toPigai (row) {
      const view = this.$router.resolve({
        path: `/jw-mock/${row.exercise_id}/${row.mock_id}/${row.paper_id}/${row.sso_id}/${row.correct_user_job_number}/${row.record_id}?correct_from=2`
      })
      window.open(view.href)
    },
    handleSelectionChange (selection) {
      this.selectionIds = []
      selection.forEach((item) => {
        this.selectionIds.push(item.correct_collection_id)
      })
    },
    search () {
      this.page = 1
      this.ifSearch = true
      this.getMyTaskList()
    },
    initForm () {
      this.searchParams = {
        moKao: '',
        submitTime: '',
        studentPhone: ''
      }
      this.page = 1
      this.ifSearch = false
      this.getMyTaskList()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getMyTaskList()
    },
    handleCurrentChange (page) {
      this.page = page
      this.getMyTaskList()
    }
  }
}
</script>

<style lang="less">
.toBeCorrectedWrapper{
  .blue{
    color: #1890ff;
    cursor: pointer;
  }
  .button-group{
    text-align: right;
  }
  .el-form-item__content {
    line-height: normal;
  }
  .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
    width: 100%;
    // width: calc(100% - 97px);
    position: relative;
    left: -4px;
    top: 1px;
    // border-top-left-radius: 0;
    // border-bottom-left-radius: 0;
  }
  // .time-prepend{
  //   display: inline-block;
  //   height: 32px;
  //   line-height: 32px;
  //   width: 90px;
  // }
  // .el-form{
  //   border-bottom: 1px solid rgb(238, 238, 238);
  // }
  .el-pagination{
    text-align: right;
    margin-top: 20px;
  }
  .opertion-wrapper{
    margin: 0px 0 10px 0;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
  }
  .search-form .form-label{
    text-align: right;
    padding-right: 10px;
  }
  .search-form{
    background: #fff;
    margin-bottom: 20px;
    padding: 20px;
  }
  .my-correction-data{
    background: #fff;
    padding: 20px;
    .has-gutter tr th{
      background-color: #eee;
    }
    .el-table {
      p {
        margin: 0;
      }
      .mock-name {
        font-size: 16px;
        span {
          margin-right: 2px;
          padding: 2px;
          font-size: 12px;
          color: #ffffff;
          background-color: #ff9966;
          border-radius: 4px;
        }
      }
      .mock-info {
        font-size: 12px;
        color: #BCBCBC;
        .mock-course {
          cursor: pointer;
        }
      }
      .mock-child {
        font-size: 12px;
      }
      .box-operate {
        a {
          text-decoration: none;
        }
        .divide-line {
          color: #BCBCBC;
          padding: 0 5px;
        }
      }
      .already {
        color: #52C41A;
      }
      .not {
        color: #FF9966;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my-correction-task/components/tobeCorrected.vue